import { useEffect, useState } from "react";
import { getEnrichmentCostBasis } from "../api";

// The tenant rate card is process-stable, so fetch it once and share the promise across
// every caller (the add dialog, the re-enrich modals, the settings page).
let cached;

/** Returns the enrichment cost basis (rate card), or null until it has loaded. */
export function useEnrichmentCostBasis() {
  const [costBasis, setCostBasis] = useState(null);
  useEffect(() => {
    cached ??= getEnrichmentCostBasis();
    let alive = true;
    cached.then((d) => { if (alive) setCostBasis(d); }).catch(() => { cached = undefined; });
    return () => { alive = false; };
  }, []);
  return costBasis;
}
